import styled from 'styled-components';

const RadioInput = styled.div`
  > input{

  position: absolute;
  display: none; 

&[disabled]{
  cursor: not-allowed; }

& + label{
  position: relative;
  display: block;
  padding-left: 30px;
  cursor: pointer;
  vertical-align: middle;
  padding-top:0px;
  color:${(props) => props.theme.blackColor};
  font-size:14px;
  }
  & + label:hover:before{
    animation-duration: 0.4s;
    animation-fill-mode: both;
    animation-name: hover-color; }
  & + label:before{
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 20px;
    height: 20px;
    content: '';
    border: solid 2px #ddd; }
  & + label:after {
    position: absolute;
    display: none;
    content: ''; }

&[disabled] + label{
  cursor: not-allowed;
  color: #e4e4e4; }
  &[disabled] + label:hover,
  &[disabled] + label:before,
  &[disabled] + label:after{
    cursor: not-allowed; }
  &[disabled] + label:hover:before{
    border: 1px solid #e4e4e4;
    animation-name: none; }
  &[disabled] + label:before {
    border-color: #e4e4e4; }

&:checked + label:before {
  animation-name: none; }

&:checked + label:after {
  display: block; }
&:checked + label {
  color:#ff0000; }

& + label:before {
  border-radius: 50%;
  
}

& + label:after {
  top: 5px;
  left: 5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.theme.primaryColor}; }

&:checked + label:before {
  border: 1px solid ${(props) => props.theme.primaryColor};
    background: ${(props) => props.theme.whiteColor};
  }

&:checked[disabled] + label:before {
  border: 1px solid #c9e2f9; }

&:checked[disabled] + label:after {
  background: #c9e2f9; }
  } 
`;

export default RadioInput;



// WEBPACK FOOTER //
// client/components/Radio/RadioInput.js